<template>
  <div id="app" :class="{ 'dark-theme': isDarkTheme && !isLoginPage }">
    <router-view />
  </div>
</template>

<script lang="ts">
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  setup() {
    const store = useStore()
    const route = useRoute()

    const isDarkTheme = computed(() => store.state.isDarkTheme)
    const isLoginPage = computed(() => route.name === 'Login' || route.path === '/' || route.path === '/cadastro')

    onMounted(() => {
      if (store.state.isAuthenticated) {
        void store.dispatch('hydrateCurrentUser')
      }
    })

    return { isDarkTheme, isLoginPage }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  width: 100%;
  overflow-x: hidden;
  background-color: var(--bg-primary);
}

#app {
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  transition: all 0.3s ease;
}

/* Tema Claro */
#app {
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --text-primary: #333333;
  --text-secondary: #666666;
  --accent-primary: #007bff;
  --accent-secondary: #6c757d;
  --border-color: #dee2e6;
  --shadow: rgba(0, 0, 0, 0.1);
  --scrollbar-track: #edf2f8;
  --scrollbar-thumb: #bcc9db;
  --scrollbar-thumb-hover: #9fb1c9;
}

/* Tema Escuro */
#app.dark-theme {
  --bg-primary: #181818;
  --bg-secondary: #1e1e1e;
  --text-primary: #ffffff;
  --text-secondary: #b8c5d6;
  --accent-primary: #007bff;
  --accent-secondary: #6c757d;
  --border-color: #333333;
  --shadow: rgba(0, 0, 0, 0.3);
  --scrollbar-track: #161a22;
  --scrollbar-thumb: #3a475d;
  --scrollbar-thumb-hover: #52627d;
}

html {
  width: 100%;
  overflow-x: hidden;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  scrollbar-width: thin;
}

* {
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  scrollbar-width: thin;
}

*::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}

*::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 999px;
  border: 3px solid var(--scrollbar-track);
}

*::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: var(--accent-primary);
  color: white;
}

.btn-primary:hover {
  opacity: 0.9;
}

.btn-secondary {
  background-color: var(--accent-secondary);
  color: white;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: var(--text-primary);
  font-weight: 500;
}

.form-group input, .form-group select {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

.table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--bg-primary);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px var(--shadow);
}

.table th, .table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-primary);
}

.table th {
  background-color: var(--bg-secondary);
  font-weight: 600;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 1000;
}

.modal-content {
  background-color: var(--bg-primary);
  padding: 30px;
  border-radius: 10px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .modal {
    align-items: flex-start;
    padding: 16px;
  }

  .modal-content {
    width: 100%;
    max-width: none;
    max-height: calc(100vh - 32px);
    margin: auto 0;
    padding: 20px;
    border-radius: 16px;
  }
}

@media (max-width: 480px) {
  .btn {
    width: 100%;
  }

  .modal {
    padding: 12px;
  }

  .modal-content {
    max-height: calc(100vh - 24px);
    padding: 16px;
  }
}
</style>
